import { useCommonEntitiesStore } from "@/States/commonEntities";
import { RadioGroup } from "@/components/RadioGroup";
import { useTrans } from "@/translations";

import { useMemo } from "react";

export const LanguageSelection = () => {
  const { t, language, changeLanguage } = useTrans();
  const { languages } = useCommonEntitiesStore();

  const options = useMemo(() => {
    return (languages || [])?.map(({ code }) => ({
      value: code,
      label: t(`languages:${code}`),
    }));
  }, [languages, t]);

  return (
    <form>
      <h2 className="font-dm-sans mx-4 mt-4 text-sm font-semibold">
        {t("configLabels:language")}
      </h2>
      <RadioGroup
        onChange={changeLanguage}
        value={language}
        options={options}
        className="m-2"
      />
    </form>
  );
};
